import { Timeline } from 'vis-timeline/peer/esm'

export function useVisTimeline(
  container,
  items = [],
  groups = [],
  options = {}
) {
  return new Timeline(container, items, groups, options)
}
